import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';
import { Balance } from '../Balance/Balance';
import { PaymentsBalanceContainer } from '../Table/PaymentsBalanceContainer';
import { useDisbursementViewController } from './DisbursementViewController';

export default function PaymentsBalanceDirectory() {
  const { actions } = useDisbursementViewController();

  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title={'Pagos y Balance'}
        sx={{ px: { xs: '16px', md: '0px' }, pb: { xs: '0px', md: '16px' } }}
        moreActions={[{ label: 'Transferir Fondos' }]}
        onMoreActionsClicked={actions.onMoreActionClicked}
      />
      <Balance />
      <PaymentsBalanceContainer />
    </TopLevelSectionLayout>
  );
}
